import type { IconGlyph } from '../icon';

/**
 * Tractie `search-thick` glyph (medium, 24×24), shown on the current nav item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/search-thick.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconSearchThick: IconGlyph = {
  name: 'search-thick',
  path: 'm20.71 19.29-4.25-4.25A7.5 7.5 0 0 0 18 10.49c0-4.14-3.36-7.5-7.5-7.5S3 6.35 3 10.49s3.36 7.5 7.5 7.5c1.71 0 3.29-.57 4.55-1.54l4.25 4.25a.996.996 0 1 0 1.41-1.41M10.5 16C7.46 16 5 13.54 5 10.5S7.46 5 10.5 5 16 7.46 16 10.5 13.54 16 10.5 16',
};
